import React from 'react';

const ShareWithGrpIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.80237 12.1184H13.9015C13.9961 12.1184 14.0867 
        12.156 14.1536 12.2228C14.2204 12.2897 14.258 12.3803 14.258 
        12.4749V17.9998H9.44592V12.4749C9.44592 12.3803 9.48348 12.2897 
        9.55032 12.2228C9.61717 12.156 9.70784 12.1184 9.80237 12.1184Z" 
        stroke="#595959" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.2586 17.9998H18.0013V9.44507C18.0013 9.30327 
        17.945 9.16727 17.8447 9.067C17.7445 8.96673 17.6085 8.9104 17.4667 
        8.9104H12.6546C12.5128 8.9104 12.3768 8.96673 12.2765 9.067C12.1763 
        9.16727 12.1199 9.30327 12.1199 9.44507V12.1184" stroke="#595959" 
        stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.4466 18H8.37726" stroke="#595959" stroke-width="1.25" 
        stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.1199 14.2578H14.2586" stroke="#595959" stroke-width="1.25" 
        stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16.3965 12.1184H18.0005" stroke="#595959" stroke-width="1.25" 
        stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16.3965 14.2578H18.0005" stroke="#595959" stroke-width="1.25" 
        stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.942 2.26465L13.6136 5.64577L9.97726 6.36492" stroke="#595959" 
        stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.8696 17.2786C4.83658 16.6427 3.98729 15.7483 3.4056 14.6838C2.82392 
        13.6192 2.52995 12.4214 2.55274 11.2085C2.57553 9.99566 2.91428 8.8097 3.53554 
        7.76778C4.1568 6.72585 5.03909 5.86399 6.09527 5.2673C7.15146 4.6706 8.34502 4.35972 
        9.55809 4.36534C10.7712 4.37096 11.9618 4.69289 13.0124 5.29934L13.6131 5.64616" 
        stroke="#595959" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
};

export default ShareWithGrpIcon;
